<template>
  <div>
    <store-header :showDoc="true" :marketInfo="marketInfo"></store-header>
    <div
      class="app-wrapper"
      v-if="enterpriseInfo && enterpriseInfo.eid && userAuthLists"
    >
      <div class="main-container">
        <div style="background: #f7f7f9">
          <div class="container">
            <div class="box">
              <div class="servertit">服务订单创建与支付</div>
              <!-- <el-alert
                style="margin: 16px 0"
                v-if="enterpriseInfo.openMarket"
                title="请注意，你所在企业为本平台商家，不能进行应用购买动作"
                type="error"
                show-icon
              ></el-alert> -->
              <el-row class="stepBox">
                <el-col :span="8">
                  <div class="currentStep">
                    <svg-icon icon-class="ok"></svg-icon>
                    <span>确定订单</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div
                    :class="
                      $route.meta.active === 1 ? 'netStep' : 'currentStep'
                    "
                  >
                    <svg-icon
                      :icon-class="$route.meta.active === 1 ? 'round' : 'ok'"
                    ></svg-icon>
                    <span>选择支付方式</span>
                  </div>
                </el-col>
                <el-col class="defaultStep" :span="8">
                  <div
                    :class="
                      $route.meta.active === 3
                        ? 'currentStep'
                        : $route.meta.active === 2
                        ? 'netStep'
                        : 'lastStep'
                    "
                  >
                    <svg-icon
                      :icon-class="
                        $route.meta.active === 3
                          ? 'ok'
                          : $route.meta.active === 2
                          ? 'round'
                          : 'lastr-round'
                      "
                    ></svg-icon>
                    <span>支付成功</span>
                  </div>
                </el-col>
              </el-row>
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-else></template>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { getMarketBaseInfoApi } from '@/api/appStore';
import { setWebInfo } from '@/utils/common';
export default {
  name: 'LayoutOrder',
  data() {
    return {
      marketInfo: {}
    };
  },
  created() {
    this.GetUserInfo();
    if (this.$route.query.marketID != undefined) {
      this.getStoreInfo(this.$route.query.marketID);
    }
  },

  computed: {
    enterpriseInfo() {
      return this.$store.state.enterprise.enterpriseInfo;
    },
    userAuthLists() {
      return this.$store.state.user.userAuths;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  methods: {
    GetUserInfo() {
      this.$store
        .dispatch('GetUserInfo')
        .then((res) => {
          if (res && res.eid) {
            this.GetUserAuths();
            this.GetCurrnetEnterpriseInfo(res.eid);
            this.GetCurrnetOrgList();
            if (res.roles.indexOf('企业管理员') != -1 || res.roles.indexOf('应用管理员') != -1) {
              window.sessionStorage.setItem('isAdmin', true);
            } else {
              if (res.roles.indexOf('普通用户') != -1) {
                window.sessionStorage.setItem('isAdmin', false);
              } else if (res.roles.indexOf('分享用户角色') != -1) {
                window.sessionStorage.setItem('isAdmin', false);
              } else {
                window.sessionStorage.setItem('isAdmin', true);
              }
            }
          } else {
            this.FedLogOut();
          }
        })
        .catch(() => {
          this.FedLogOut();
        });
    },
    GetUserAuths() {
      this.$store
        .dispatch('GetUserAuthList')
        .then((res) => {})
        .catch(() => {
          this.FedLogOut();
        });
    },
    GetCurrnetEnterpriseInfo(eid) {
      this.$store
        .dispatch('GetEnterpriseInfo', eid)
        .then(() => {
          return null;
        })
        .catch(() => {
          this.FedLogOut();
        });
    },
    GetCurrnetOrgList(eid) {
      this.$store
        .dispatch('GetUserOrgList', eid)
        .then(() => {
          return null;
        })
        .catch(() => {
          this.FedLogOut();
        });
    },
    FedLogOut() {
      this.$store.dispatch('FedLogOut').then(() => {
        this.$router.push({
          name: 'login',
          query: { redirect: this.$route.fullPath }
        });
      });
    },
    getStoreInfo(marketID) {
      if (marketID == undefined || marketID == '') {
        return;
      }
      getMarketBaseInfoApi({
        marketId: marketID
      })
        .then((res) => {
          this.marketInfo = res;
          setWebInfo('AI智能体市场-' + res.name, res.description);
        })
        .catch((err) => {});
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.sidebar-container {
  background: #fff;
  flex-grow: 0;
}
.main-container {
  flex-grow: 1;
  margin: 0 auto;
}
</style>
<style rel="stylesheet/scss" lang="scss">
.container {
  width: 1200px;
  margin: 0 auto;
}
.stepBox {
  overflow: hidden;

  .el-col-8 {
    & > div {
      background: #e6eff8;
      height: 46px;
      margin: 21px 0 26px 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      span {
        margin-left: 5px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
  }
}

.currentStep {
  background: rgba(0, 94, 186, 1) !important;
  :after {
    content: '';
    position: absolute;
    z-index: 1;
    display: inline-block;
    right: -16px;
    width: 0;
    height: 0;
    top: 14px;
    border: 9px solid transparent;
    // border-left-color: #1890ff;
  }
  span {
    color: #fff;
  }
}
.netStep {
  span {
    color: rgba(0, 94, 186, 1) !important;
  }
}
.lastStep {
  span {
    color: rgba(84, 88, 90, 1) !important;
  }
}
.stepss {
  background: rgba(247, 250, 251, 1);
  margin: 21px 0 26px 0 !important;
}
.servertit {
  height: 40px;
  font-size: 16px;
  font-family: FZLTHJW--GB1-0, FZLTHJW--GB1;
  font-weight: normal;
  color: rgba(84, 88, 90, 1);
  line-height: 40px;
  border-bottom: 1px solid #54585a;
}
.mt77 {
  margin-top: 77px;
}
.box {
  padding: 16px;
  background: #ffffff;
  margin-top: 16px;
}

.title-text {
  margin: 0 auto;
  height: 40px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid rgb(211, 206, 206);
  line-height: 40px;
}

.el-step__title .is-process {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/LayoutOrder.vue